import React from 'react';
import { Link } from 'react-router-dom';
// @ts-ignore
import { FaInfoCircle } from 'react-icons/fa';

interface HeroSectionProps {
  isLoaded: boolean;
}

const HeroSection: React.FC<HeroSectionProps> = ({ isLoaded }) => {
  // isLoaded is currently received but not consumed inside HeroSection — the
  // .left-section wrapper that uses it lives in the orchestrator (Home.tsx)
  // because .left-section also wraps RecentProjects and we must preserve the
  // original single-wrapper DOM layout. The prop is plumbed for future use
  // by Phase 33's HOME-02 letter-by-letter animation hook.
  void isLoaded;

  return (
    <div className="name-container">
      <h1 className="title title-first">I'M</h1>
      <h1 className="title title-second">CHRISTOPHER</h1>
      <h1 className="title title-third">FABIAN
        <Link to="/about" className="info-icon-link">
          <FaInfoCircle className="info-icon"/>
        </Link>
      </h1>
    </div>
  );
};

export default React.memo(HeroSection);
